
import React from "react";
import VideoGridItem from "./VideoGridItem";

interface Video {
  id: string;
  url: string;
  title: string;
  createdAt: string;
}

interface VideoGridProps {
  videos: Video[];
  onDelete: (videoId: string, filePath: string) => Promise<void>;
  onAnalyze: (video: Video) => void;
  getFilenameFromUrl: (url: string) => string;
}

const VideoGrid: React.FC<VideoGridProps> = ({
  videos,
  onDelete,
  onAnalyze,
  getFilenameFromUrl,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {videos.map((video) => (
        <VideoGridItem
          key={video.id}
          video={video}
          onDelete={onDelete}
          onAnalyze={onAnalyze}
          getFilenameFromUrl={getFilenameFromUrl}
        />
      ))}
    </div>
  );
};

export default VideoGrid;
